import { createSlice } from '@reduxjs/toolkit'
// import axios from 'axios'
import api from '../../api/index'
import { startLoading, stopLoading } from './loadingSlice'
import {
  failed,
  success,
} from './snackSlice'
import i18n from '../../i18n'

export const examSlice = createSlice({
  name: 'exam',
  initialState: {
    userExam: {},
    searchExam: {},
    selectedExam: {
      exam: {},
      answers: [],
    },
    answeredExam: [],
    finishResult: {},
    examErr: false,
  },
  reducers: {
    examFetched: (state, { payload }) => {
      state.exams = payload
    },
    allExamFetched: (state, { payload }) => {
      state.allExams = payload
    },
    singleExamFetched: (state, { payload }) => {
      state.exam = payload
    },
    searchExamFetched: (state, { payload }) => {
      state.searchExam = payload
    },
    selectedExamFetched: (state, { payload }) => {
      state.selectedExam = {
        ...state.selectedExam,
        ...payload,
      }
    },
    userExamAnswerFetched: (state, { payload }) => {
      state.selectedExam = {
        ...state.selectedExam,
        answers: payload,
      }
    },
    clearExam: (state) => {
      state.selectedExam = {
        exam: {},
        answers: [],
      }
    },
    userAnsweredFetched: (state, { payload }) => {
      state.answeredExam = payload
    },
    quizResponseFetch: (state, { payload }) => {
      state.finishResult = payload
    },
    examQuestionsFetch: (state, { payload }) => {
      state.questions = payload
    },
    examQuestionsErr: (state, { payload }) => {
      state.examErr = payload
    },
  },
})

export default examSlice.reducer

export const {
  examFetched,
  allExamFetched,
  singleExamFetched,
  searchExamFetched,
  selectedExamFetched,
  userExamAnswerFetched,
  clearExam,
  userAnsweredFetched,
  quizResponseFetch,
  examQuestionsFetch,
  examQuestionsErr,
} = examSlice.actions

export const getAllExams = () => (dispatch) => {
  const url = '/exam/question?after=0&first=100'
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      const ex = res?.data?.data
      if (ex) dispatch(allExamFetched(ex))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getSearchExam = () => (dispatch) => {
  const url = '/exam?after=0&first=10&name=آزمون&optionCount=4'
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      const ex = res?.data?.data
      if (ex) dispatch(searchExamFetched(ex))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getUserAnswered = (params) => (dispatch) => {
  const url = '/exam/user/answer'
  dispatch(startLoading())
  api
    .get(url, { params })
    .then((res) => {
      const answeres = res?.data?.data
      if (answeres) dispatch(userAnsweredFetched(answeres))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getUserExams = (params) => (dispatch) => {
  const url = '/exam/question'
  dispatch(startLoading())
  api
    .get(url, { params })
    .then((res) => {
      const ex = res?.data?.data
      dispatch(quizResponseFetch(res))
      if (ex) dispatch(singleExamFetched(ex))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(quizResponseFetch(e?.response?.data?.message))
      dispatch(failed(e?.response?.data?.message, ''))
      // if (e?.response?.data?.message === 'Exam has been finished') {
      //   dispatch(failed(i18n.t('finishedQuiz')))
      // } else {
      //   dispatch(failed(e?.response?.data?.message ?? ''))
      // }

      dispatch(stopLoading())
    })
}

export const getUserExamQuestionsTemp = (params) => (dispatch) => {
  dispatch(startLoading())
  api
    .get('/exam/question', { params })
    .then(({ data = { data: [] } }) => {
      const examData = data?.data[0].exam
      const questions = data.data.sort((a, b) => (a?.category && a?.category.id < b?.category))

      dispatch(selectedExamFetched({
        totalHits: data.totalHits,
        exam: { ...examData, questions },
      }))

      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getExamQuestionsTemp = (params) => (dispatch) => {
  dispatch(startLoading())
  api
    .get('/exam/question', { params })
    .then(({ data = { data: [] } }) => {
      const examData = data?.data[0].exam
      const questions = data.data.sort((a, b) => (a?.category && a?.category.id < b?.category))

      dispatch(selectedExamFetched({
        totalHits: data.totalHits,
        exam: { ...examData, questions },
      }))

      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const answerQuiz = (data, callback) => (dispatch) => {
  const url = '/exam/user/answer'
  dispatch(startLoading())
  api({
    method: 'post',
    url,
    headers: {
      'Content-Type': ' application/json',
    },
    data,
  })
    .then(() => {
      // dispatch(success(i18n.t('answer_successfuly')))
      if (callback && typeof (callback) === 'function') callback()
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message ?? ''))
      return 'error'
    })
}

export const answerQuestion = (data, callback) => (dispatch) => {
  const url = '/exam/user/Answer'
  dispatch(startLoading())
  api({
    method: 'post',
    url,
    headers: {
      'Content-Type': ' application/json',
    },
    data,
  })
    .then(() => {
      // dispatch(success(i18n.t('answer_successfuly')))
      if (callback && typeof (callback) === 'function') callback()
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message ?? ''))
      return 'error'
    })
}

export const getUserExamAnswers = (params) => (dispatch) => {
  dispatch(startLoading())
  api.get('/exam/user/answer', { params })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(userExamAnswerFetched(res?.data?.data || []))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
      return 'error'
    })
}

export const finishUserExamTemp = (userExamId) => (dispatch) => {
  dispatch(startLoading())
  api.get(`/exam/user/finish/${userExamId}`)
    .then((res) => {
      dispatch(quizResponseFetch(res))
      dispatch(stopLoading())
      dispatch(examQuestionsErr(false))
      // dispatch(examQuestionsResCode(res?.data?.))
      dispatch(success(i18n.t('exam_successfuly')))
    })
    .catch((e) => {
      dispatch(quizResponseFetch(e?.response?.data?.message))
      dispatch(examQuestionsErr(true))
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
      return 'error'
    })
}

// export const answerTemp = (data, params) => (dispatch) => {
//   dispatch(startLoading())
//   api({
//     method: 'post',
//     url: '/exam/user/answer',
//     headers: {
//       'Content-Type': ' application/json',
//     },
//     data,
//   })
//     .then(() => {
//       dispatch(stopLoading())
//       dispatch(getUserExamAnswers(params))
//     })
//     .catch((e) => {
//       console.log(e)
//       dispatch(failed(e?.response?.data?.message ?? ''))
//       dispatch(stopLoading())
//     })
// }

export const answerTemp = (data) => (dispatch) => {
  dispatch(startLoading())
  api({
    method: 'post',
    url: '/exam/user/answer',
    headers: {
      'Content-Type': ' application/json',
    },
    data,
  })
    .then(() => {
      dispatch(stopLoading())
      // dispatch(getUserExamAnswers(params))
    })
    .catch((e) => {
      console.log(e)
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const finishQuiz = (userExamId) => (dispatch) => {
  const url = `/exam/user/finish/${userExamId}`
  dispatch(startLoading())
  api.get(url)
    .then((res) => {
      console.log(res)
      console.log(res?.data)
      console.log(res?.data?.code)
      console.log(res?.data?.success)
      dispatch(success(i18n.t('answer_successfuly')))
      // if (res?.response?.data?.message === 'Exam has been finished') {
      //   dispatch(success(i18n.t('answer_successfuly')))
      // }
      dispatch(quizResponseFetch(res))
      dispatch(stopLoading())
    })
    .catch((e) => {
      console.log(e)
      dispatch(quizResponseFetch(e?.response?.data?.message))
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
      return 'error'
    })
}

export const getUserExamQuestions = (params) => (dispatch) => {
  dispatch(startLoading())
  api.get('/exam/question', { params })
    .then((res) => {
      dispatch(stopLoading())
      dispatch(examQuestionsFetch(res?.data?.data || []))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
      return 'error'
    })
}

export const clearSelectedExam = () => (dispatch) => {
  dispatch(clearExam())
}

export const selectorExams = (state) => state.exam.exams
export const selectorExam = (state) => state.exam.exam
export const selectorAllExams = (state) => state.exam.allExams
export const selectorSearchExam = (state) => state.exam.searchExam
export const selectorAnsweredExam = (state) => state.exam.answeredExam
export const selectorFinishResult = (state) => state.exam.finishResult
export const selectorExamQuestions = (state) => state.exam.questions
export const selectorExamQuestionsErr = (state) => state.exam.examErr
